<ng-container *ngIf="isLoading; else unavailable">
  <div class="process-header">
    <h1>Proszę czekać</h1>
  </div>

  <div class="process-content">
    <div class="inner">
      <p>Pobieram dane...</p>
    </div>
  </div>
</ng-container>

<ng-template #unavailable>
  <div class="process-header">
    <h1>Raport niedostępny</h1>
  </div>

  <div class="process-content">
    <div class="inner">
      <div class="report-expired">
        <h4>
          Ze względów bezpieczeństwa raport jest dostępny przez 72 godziny od momentu utworzenia.
          Jeśli ten czas minął, dostęp do raportu został automatycznie zakończony.
          Raport został usunięty z systemu.
          Aby sprawdzić aktualne dane osoby zmarłej, możesz zamówić nowy raport.
        </h4>

        <a
          class="cta cta--bold"
          [routerLink]="['/']"
          fragment="products"
          [ngxScrollTo]="'#products'"
          [ngxScrollToOffset]="-200"
        >
          Zamów nowy raport
        </a>
      </div>
    </div>
  </div>
</ng-template>
